export const FETCH_PROFITLOSS_REQUEST = "FETCH_PROFITLOSS_REQUEST";
export const FETCH_PROFITLOSS_SUCCESS = "FETCH_PROFITLOSS_SUCCESS";
export const FETCH_PROFITLOSS_FAILURE = "FETCH_PROFITLOSS_FAILURE";